import { render, staticRenderFns } from "./GoodsBox.vue?vue&type=template&id=05b10bad&scoped=true&"
import script from "./GoodsBox.vue?vue&type=script&lang=js&"
export * from "./GoodsBox.vue?vue&type=script&lang=js&"
import style0 from "./GoodsBox.vue?vue&type=style&index=0&id=05b10bad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b10bad",
  null
  
)

export default component.exports